<template>

    <div>

        <div class="section">
            <vue-dropzone
                ref="vueDropzone"
                id="vueDropzone"
                url= "fileProcessing/upload?preset=shopix"
                :maxFiles="1"
                acceptedFiles=".zip"
                dictDefaultMessage="<i class='fa fa-cloud-upload'></i>ZIP hochladen"
                v-on:vdropzone-success="dzSuccess"
                v-on:vdropzone-mounted="dzInit"
                dzClass="default dzSingle">
            </vue-dropzone>
        </div>

        <div class="section">

            <loading-indicator :loading="isLoading"></loading-indicator>

            <template v-if="!isLoading">

                <div class="columns" v-for="entry in shopixData" :key="entry.file">

                    <div class="column">
                        {{ entry.name }}
                    </div>

                    <div class="column is-narrow">
                        {{ entry.file }}
                    </div>

                </div>

            </template>

        </div>


        <!-- MODAL -->
        <modal
            width="640"
            transition="fadeDown"
            cancel-text="Abbrechen"
            :show-ok="false"
            title="Upload"
            :backdrop-closable="false"
            :is-show="showModal"
            @close="closeModal">

                <template v-if="modal.isLoading">
                    <loading-indicator></loading-indicator>
                </template>

                <template v-else>

                    <template v-if="progressStatus == null">

                        <loading-indicator-small></loading-indicator-small>

                    </template>

                    <template v-else>

                        <template v-if="progressStatus.status != 'Finished'">

                            <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                            <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                        </template>

                        <template v-else>

                            <div class="notification is-success">
                                <span class="icon"><i class="fa fa-check"></i></span>
                                <span>Datei wurde erfolgreich hochgeladen</span>
                            </div>


                            <div slot="footer">

                                <span :class="['button', { 'is-disabled': modal.isSaving || modal.isLoading }]" @click="closeModal">schließen</span>

                            </div>

                        </template>

                    </template>

                </template>

        </modal>


    </div>

</template>


<script>
import vue2Dropzone from '../../utils/dropzoneWrapper'

export default {

    components: {
        vueDropzone: vue2Dropzone,
    },

    data() {

        return {
            isLoading: false,
            shopixData: null,

            refreshIntervalId: null,
            progressStatus: null,

            showModal: false,

            modal: {
                isLoading: false,
                isSaving: false,
            }
        }
    },

    created() {

        this.init();

    },

    methods: {

        init() {

            this.isLoading = true;

            // http://datenbank.apothekenkatalog.at/herba/public/api/taskLog?filters[task]=29&showMetafields=1
            return this.axios.get(this.$config.api + 'pim/shopix').then(res => {
                this.shopixData = res.data;
                this.isLoading = false;
            })

        },


        dzSuccess(file, response) {

            var self = this;
            this.modal.isLoading = false;
            this.modal.isSaving = false;

            this.showModal = true;


            this.$refs.vueDropzone.$children[0].removeAllFiles();
            let taskLogId = response.taskLogId;

            self.refreshIntervalId = setInterval(function() {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                    .then(response => {

                        self.progressStatus = response.data;

                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                            clearInterval(self.refreshIntervalId);

                            this.init().then(res => {

                                // self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                // self.closeModal();

                            })

                            /*
                            self.axios.get(self.$config.api + 'newsletter/subscribers?site='+self.siteId)
                                .then(function(response) {
                                    self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                    self.recipients.data = response.data;
                                    self.closeModal();
                                })
                            */

                        }

                    });

            }.bind(self), 1000);


            setTimeout(function() {

                clearInterval(self.refreshIntervalId);
                self.showModal = false;

            }, 100000);

        },

        closeModal() {

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);

            this.progressStatus = null;

            this.modal.isSaving = false;
            this.showModal = false;

        },

    }


}

</script>

<style lang="scss" scoped>
    .section {
        max-width: 640px;
    }
    .columns {
        .column {
            padding-top: 6px;
            padding-bottom: 6px;
        }
    }
    .notification {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 320px;
        margin: 0 auto;
        text-align: center;

        .icon {
            margin-right: 8px;
        }
    }
</style>
